import { IconButton, makeStyles, Snackbar, SnackbarContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Alert } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import { fetchMaintenceMessage } from 'services/alert';

const useStyles = makeStyles((theme) => ({
  alert: {},
}));

const MaintenceAlert = () => {
  const [message, setMessage] = useState('');
  const classes = useStyles();

  const removeMessage = () => {
    setMessage('');
  };

  useEffect(() => {
    fetchMaintenceMessage().then(setMessage);
  }, []);

  return (
    <Snackbar
      className={classes.alert}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={message !== ''}
    >
      <Alert
        severity='warning'
        action={
          <IconButton onClick={removeMessage}>
            <CloseIcon />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MaintenceAlert;
